import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { HexColorPicker } from 'react-colorful'
import styles from './styles.module.css'

export const InlineColorPicker = ({ 
  isOpen, 
  initialColor = '#000000', 
  onColorChange
}) => {
  const { t } = useTranslation()
  const [tempColor, setTempColor] = useState(initialColor)

  useEffect(() => {
    setTempColor(initialColor)
  }, [initialColor, isOpen])

  if (!isOpen) return null

  // Funções auxiliares
  const hexToRgb = (hex) => {
    const cleanHex = hex.replace('#', '')
    if (cleanHex.length !== 6) return { r: 0, g: 0, b: 0 }
    const r = parseInt(cleanHex.substring(0, 2), 16)
    const g = parseInt(cleanHex.substring(2, 4), 16)
    const b = parseInt(cleanHex.substring(4, 6), 16)
    return { r, g, b }
  }

  const rgbToHex = (r, g, b) => {
    const toHex = (num) => {
      const hex = Math.max(0, Math.min(255, num)).toString(16)
      return hex.length === 1 ? '0' + hex : hex
    }
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase()
  }

  const handleColorChange = (newColor) => {
    setTempColor(newColor)
    const hex = newColor.replace('#', '').toUpperCase()
    if (/^[0-9A-F]{6}$/i.test(hex) && onColorChange) {
      onColorChange(hex)
    }
  }

  const handleHexChange = (e) => {
    const value = e.target.value
    setTempColor(value)
    if (/^#[0-9A-F]{6}$/i.test(value)) {
      handleColorChange(value)
    }
  }

  const handleRgbChange = (type, value) => {
    const num = parseInt(value) || 0
    const rgb = hexToRgb(tempColor)
    let newHex
    if (type === 'r') newHex = rgbToHex(num, rgb.g, rgb.b)
    if (type === 'g') newHex = rgbToHex(rgb.r, num, rgb.b)
    if (type === 'b') newHex = rgbToHex(rgb.r, rgb.g, num)
    handleColorChange(newHex)
  }

  const rgb = hexToRgb(tempColor)

  return (
    <div className={styles.pickerContainer}>
      <div className={styles.pickerArrow}></div>
      <div className={styles.pickerContent}>
        <HexColorPicker
          // style={{width: '100%', height: '100%', gap: '26px'}}
          color={tempColor}
          onChange={handleColorChange}
        />
        <div className={styles.colorInputs}>
          <div className={styles.inputGroup}>
            <label>{t('chatsocket.color.hex')}</label>
            <input
              type="text"
              className={styles.colorInput}
              value={tempColor}
              onChange={handleHexChange}
              placeholder={t('chatsocket.color.hex_placeholder')}
            />
          </div>
          <div className={styles.inputGroup}>
            <label>{t('chatsocket.color.r')}</label>
            <input
              type="number"
              className={styles.colorInput}
              value={rgb.r}
              onChange={(e) => handleRgbChange('r', e.target.value)}
              min="0"
              max="255"
            />
          </div>
          <div className={styles.inputGroup}>
            <label>{t('chatsocket.color.g')}</label>
            <input
              type="number"
              className={styles.colorInput}
              value={rgb.g}
              onChange={(e) => handleRgbChange('g', e.target.value)}
              min="0"
              max="255"
            />
          </div>
          <div className={styles.inputGroup}>
            <label>{t('chatsocket.color.b')}</label>
            <input
              type="number"
              className={styles.colorInput}
              value={rgb.b}
              onChange={(e) => handleRgbChange('b', e.target.value)}
              min="0"
              max="255"
            />
          </div>
        </div>
      </div>
    </div>
  )
}